import React from "react";
import "./PoolOverviewCard.css";
import { FaClock, FaUserCheck, FaExclamationTriangle, FaRulerCombined, FaWater, FaLightbulb, FaCouch, FaUtensils, FaTshirt, FaExchangeAlt, FaShieldAlt, FaCheckCircle, FaChild } from "react-icons/fa";

const SwimmingPool = () => {
  const [activeAccordion, setActiveAccordion] = React.useState(null);

  const toggleAccordion = (index) => {
    setActiveAccordion((prev) => (prev === index ? null : index));
  };

  return (
    <div className="swimming-pool-page">
      {/* 1️⃣ Pool Overview */}
      <div className="pool-overview-card">
        <div className="banner-image">
          <img
            src="https://tse2.mm.bing.net/th/id/OIP.RBtkhh0GsHeOMB7OuNyhlQHaE8?r=0&rs=1&pid=ImgDetMain&o=7&rm=3"
            alt="Infinity pool at sunset"
          />
        </div>
        {/* <div className="card-content">
          <h1>Pool Overview</h1>
          <p>Experience our elegant infinity pool, designed for leisure and style.</p>
          <div className="features">
            <div className="feature"><FaRulerCombined /> <span><strong>Size:</strong> 25m x 10m</span></div>
            <div className="feature"><FaWater /> <span><strong>Depth:</strong> 3ft to 6ft</span></div>
            <div className="feature"><FaLightbulb /> <span><strong>Lighting:</strong> LED & Underwater Glow</span></div>
          </div>
        </div> */}
      </div>

      {/* 2️⃣ Access & Usage */}
      <div className="access-usage-info">
        <h3>Access & Usage</h3>
        <p>Know when and how to enjoy the pool with safety and comfort.</p>
        <div className="usage-items">
          <div className="usage-item"><FaClock /><span><strong>Time:</strong> 6 AM – 10 PM (night swim on weekends)</span></div>
          <div className="usage-item"><FaUserCheck /><span><strong>Guest Access:</strong> Free for all registered guests</span></div>
          <div className="usage-item"><FaExclamationTriangle /><span><strong>Rules:</strong> No diving, no running, children must be supervised</span></div>
        </div>
      </div>

      {/* 3️⃣ Poolside Amenities */}
      <div className="poolside-amenities">
        <h3>🪑 Poolside Amenities</h3>
        <div className="amenities-grid">
          <div className="amenity-card"><FaCouch /><p>Lounge Chairs</p></div>
          <div className="amenity-card"><FaUtensils /><p>Snack Bar</p></div>
          <div className="amenity-card"><FaExchangeAlt /><p>Changing Rooms</p></div>
          <div className="amenity-card"><FaTshirt /><p>Towel Services</p></div>
        </div>
      </div>

      {/* 4️⃣ Events at Poolside */}
     <div className="pool-events">
  <h1>Events at Poolside</h1>
  <div className="event-gallery">
    <div className="event-card">
      <img
        src="https://tse1.mm.bing.net/th/id/OIP.igX0pKG8tSolV9g5hPkfUwAAAA?r=0&rs=1&pid=ImgDetMain&o=7&rm=3"
        alt="Pool Party"
      />
      <div className="overlay">Pool Parties</div>
    </div>
    <div className="event-card">
      <img
        src="https://images.pexels.com/photos/7294545/pexels-photo-7294545.jpeg?cs=srgb&dl=pexels-kindel-media-7294545.jpg&fm=jpg"
        alt="Event Celebration"
      />
      <div className="overlay">Event Celebrations</div>
    </div>
    <div className="event-card">
      <img
        src="https://watermark.lovepik.com/photo/20211204/large/lovepik-couple-relaxing-in-swimming-pool-picture_501515445.jpg"
        alt="Couple Photoshoot"
      />
      <div className="overlay">Couple Photoshoots</div>
    </div>
    <div className="event-card">
      <img
        src="https://d2gg9evh47fn9z.cloudfront.net/800px_COLOURBOX5179993.jpg"
        alt="Night Swim"
      />
      <div className="overlay">Night Swims</div>
    </div>
  </div>
</div>


      {/* 5️⃣ Safety & Maintenance */}
      <div className="safety-maintenance">
        <h1>Safety & Maintenance</h1>
        <div className="accordion">
          {[
            {
              title: "Lifeguard Availability",
              icon: <FaShieldAlt />,
              content: "Certified lifeguards are on duty from 6 AM to 10 PM."
            },
            {
              title: "Water Quality Checks",
              icon: <FaCheckCircle />,
              content: "Water is tested daily for clarity and cleanliness."
            },
            {
              title: "Kids’ Safety Measures",
              icon: <FaChild />,
              content: "Kids under 12 require adult supervision. Float gear provided."
            },
          ].map((item, index) => (
            <div
              className={`accordion-item ${activeAccordion === index ? "active" : ""}`}
              key={index}
            >
              <div className="accordion-header" onClick={() => toggleAccordion(index)}>
                {item.icon} <span>{item.title}</span>
                <span className="symbol">{activeAccordion === index ? "−" : "+"}</span>
              </div>
              {activeAccordion === index && (
                <div className="accordion-content">
                  <p>{item.content}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SwimmingPool;